module.exports = __webpack_public_path__ + "prod/1.42.2/img/power3.5f1eb7ff.png";